import { ENGINEER, PROJECT_ADMIN, SUBCONTRACTOR, SUPER_ADMIN } from "@/constants/roles";
import {
  Boxes,
  Briefcase,
  ChartArea,
  FileSpreadsheet,
  FolderOpenDot,
  Landmark,
  Menu,
  User,
  X,
} from "lucide-react";
import { Link } from "react-router-dom";

import SideMenu from "./Menu";

export interface SidebarItem {
  icon: React.ElementType;
  name: string;
  link: string;
  routes: string[];
  roles: string[];
}

const sidebarItemsSettings: SidebarItem[] = [
  {
    icon: FolderOpenDot,
    name: "Projects",
    link: "/settings/projects",
    routes: ["/settings/projects"],
    roles: [SUPER_ADMIN],
  },
  {
    icon: ChartArea,
    name: "Levels",
    link: "/settings/levels",
    routes: ["/settings/levels"],
    roles: [SUPER_ADMIN, PROJECT_ADMIN],
  },
  {
    icon: Briefcase,
    name: "Companies",
    link: "/settings/companies",
    routes: ["/settings/companies"],
    roles: [SUPER_ADMIN, PROJECT_ADMIN],
  },
  {
    icon: User,
    name: "Users",
    link: "/settings/users",
    routes: ["/settings/users"],
    roles: [SUPER_ADMIN, PROJECT_ADMIN],
  },
  {
    icon: Boxes,
    name: "User Groups",
    link: "/settings/user-groups",
    routes: ["/settings/user-groups"],
    roles: [SUPER_ADMIN, PROJECT_ADMIN],
  },
  {
    icon: Landmark,
    name: "Lookups",
    link: "/settings/lookups",
    routes: ["/settings/lookups"],
    roles: [SUPER_ADMIN, PROJECT_ADMIN],
  },
  {
    icon: FileSpreadsheet,
    name: "Reports",
    link: "/settings/reports",
    routes: ["/settings/reports"],
    roles: [SUPER_ADMIN, PROJECT_ADMIN, ENGINEER, SUBCONTRACTOR],
  },
];

interface SidebarProps {
  selected: boolean;
  setSelected: (selected: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ selected, setSelected }) => {
  const handleOverlayClick = () => {
    setSelected(false);
  };

  return (
    <>
      <div
        className={`lg:hidden  ${
          selected ? "opacity-100 visible" : " opacity-0 invisible"
        } fixed inset-0 bg-black/30 z-[999] transition-all duration-300`}
        onClick={handleOverlayClick}
      ></div>
      <div
        className={`max-w-full   ${
          selected
            ? "lg:w-[54px!important] w-[280px!important] translate-x-0 "
            : "w-[280px!important] -translate-x-full"
        }  lg:pt-2 pt-4 fixed top-0 bottom-0 z-[999] h-full flex flex-col bg-[#004578] lg:translate-x-0 transition-all duration-300`}
      >
        <div
          className={`flex items-center w-full px-3 pb-10 ${
            selected ? "lg:justify-center" : "justify-between"
          }`}
        >
          {!selected && (
            <Link to={"/home"} className="inline-flex items-center gap-2">
              <img
                src="https://peopleflow-dev.alec.ae/images/brand-white.png"
                alt="Brand Logo"
              />
              <span
                className={`text-white text-lg font-bold font-kanit tracking-[-0.04px]`}
              >
                AAR
              </span>
            </Link>
          )}
          <button
            onClick={() => setSelected(!selected)}
            className="p-0 border-none outline-none text-white"
          >
            <Menu />
          </button>
        </div>
        <div className="flex-1">
          <SideMenu
            selected={selected}
            sidebarItemsSettings={sidebarItemsSettings}
          />
        </div>
      </div>
    </>
  );
};

export default Sidebar;
